// extracted by mini-css-extract-plugin
export default {"or":"EnterRecipient_or__9lQ8p"};